import { render, staticRenderFns } from "./BgLayerList.vue?vue&type=template&id=6e11cb72&"
import script from "./BgLayerList.vue?vue&type=script&lang=js&"
export * from "./BgLayerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports